import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { VBox } from '../../../components/Box';
import { translateCountry } from '../../Companies/translate-countries';

const Container = styled.div`
  width: 90%;
  font-size: 14px;
  h3 {
    font-size: 20px;
  }

  .address {
    width: 100%;
    border: 1px solid var(--color-new-grey);
    border-radius: 12px;
    padding: 12px;
    margin: 12px;
    .name {
      font-weight: 600;
    }

    &.selected {
      border: 2px solid var(--color-new-secondary);
    }
  }

  .req-field-message {
    color: red;
  }
`;

const AddressView = ({ address, selected, selectAddress, company_name, locale, lbl, key }) => {
  const onSelect = a => {
    selectAddress(a);
  };
  return (
    <Container key={key}>
      <VBox
        className={`address ${selected ? 'selected' : ''}`}
        key={address.id}
        onClick={() => {
          address.country && onSelect(address);
        }}
      >
        {company_name && company_name} <br />
        <div className="name">{lbl(`address.type.${address?.type?.name || 'other'}`)}</div>
        {address.addressLine1} <br /> {address.postcode}&nbsp;{address.city}
        <br />
        {translateCountry(address.country?.name, locale) || ''}
        {!address.country && <div className="req-field-message">{'Country is required *'}</div>}
      </VBox>
    </Container>
  );
};

export default AddressView;
